<ps-ui-modal class="sup-group-modal launch-confirmation-modal">
  <span psUiModalTitle>
    <strong>Before you launch this survey, please ensure that you've:</strong>
  </span>
  <ps-ui-modal-body class="text-muted">
    <p>1. Reviewed audience targeting</p>
    <p>2. Confirmed pricing and supplier allocation</p>
    <p *ngIf="isPriceGreaterThanCpiThreshold" class="pricing-info">
      Your survey is set to {{ pricingDetails.type }} with
    </p>
    <p *ngIf="isPriceGreaterThanCpiThreshold" class="pricing-info">
      CPI {{ pricingDetails.value }}
    </p>
    <p *ngIf="isPriceGreaterThanCpiThreshold" class="pricing-info">
      <input
        id="confirm-launch"
        type="checkbox"
        class="form-check-input"
        [(ngModel)]="pricingAccepted"
      />
      I understand and accept this pricing
    </p>
    <p>3. Tested link set up for a survey termination</p>
    <br />
    <p>To proceed launching, click Launch your Survey!</p>
  </ps-ui-modal-body>
  <ps-ui-modal-footer>
    <button type="button" class="btn btn-default" (click)="close('Cancel')">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="close('Launch')"
      psUiGtagEvent
      trackOn="click"
      action="launch_survey"
      category="Survey_Launch"
      [params]="{ event_label: 'Survey Launched' }"
    >
      Launch Your Survey
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
